import { createContext, FC, ReactNode, useContext, useState } from "react";

import { CHAT_TYPES } from "@constants/chat";

import { Conversation } from "@components/AssistantChat/type";
import { useConversations, useMessages } from "@components/Conversation/hooks";

import { useUserStore } from "./user.state";

interface IToasterContextProps {
  children: ReactNode;
}

interface Draft {
  text: string;
  imageUrls: { name: string; url: string }[];
  fileUrls: { name: string; url: string }[];
}

interface UseGawainAssistant {
  currentSession: string;
  setCurrentSession: (sessionId: string) => void;
  draft: Draft;
  setDraft: (draft: Draft) => void;
  conversations: Conversation[];
  loadingConversations: boolean;
  loadingMessages: boolean;
  messages: any[];
}

export const GawainAssistantContext = createContext(null);

export const useGawainAssistant = () =>
  useContext<UseGawainAssistant>(GawainAssistantContext);

const GawainAssistantProvider: FC<IToasterContextProps> = ({ children }) => {
  const { user } = useUserStore();

  const [currentSession, setCurrentSession] = useState<string>();
  const [draft, setDraft] = useState<Draft>(null);

  const [conversations, loadingConversations] = useConversations(
    user?.id,
    CHAT_TYPES.ASSISTANT
  );
  const [messages, loadingMessages] = useMessages(currentSession);

  return (
    <GawainAssistantContext.Provider
      value={{
        currentSession,
        setCurrentSession,
        draft,
        setDraft,
        conversations,
        loadingConversations,
        messages,
        loadingMessages,
      }}
    >
      {children}
    </GawainAssistantContext.Provider>
  );
};

export default GawainAssistantProvider;
